const GA_TRACKING_ID = 'UA-109032821-3';

interface Target extends EventTarget {
  tagName: string;
  className: string;
  getAttribute: (arg0: string) => string;
  parentNode: Target;
}

interface Global extends Window {
  gtag: (arg0: string, arg1: string, arg2: object) => void;
  rtag?: (arg0: string, ...rest: any) => void;
}

const g = window as unknown as Global;

enum CLIENT_TYPE {
  APP = 'app',
  MINIPROGRAM = 'miniprogram',
  H5 = 'h5',
}

const rlogClientMap = {
  [CLIENT_TYPE.APP]: {
    account: '18',
    secret: 'cc299025dbaf4459b9a7f396294ea393',
  },
  [CLIENT_TYPE.MINIPROGRAM]: {
    account: '36',
    secret: 'ca9d08955905419cb69282d68206bf2d',
  },
  [CLIENT_TYPE.H5]: {
    account: '27',
    secret: '63fa75477bee453da13fc77b7143bd67',
  }
}

const gaUtil = {
  /**
   * 对标签自动埋点，使用规则, 给元素添加ga-click类，并添加 data-cate/ action等,（参考云课堂实现）
   * @example <div class="ga-click"  data-cate="轮播图" data-action="点击" data-label="xxx"></div
   */
  autoGA() {
    document.addEventListener('click', (e) => {
      let ele = e.target as Target;
      // 从点前开始，向上遍历，找到第一个存在ga-click的元素,知道body
      while (!!ele && ele.tagName && ele.tagName.toLowerCase() !== 'body') {
        // svg的话需要这么判断
        if (typeof ele.className === 'string' && ele.className.indexOf('ga-click') !== -1) {
          const category = ele.getAttribute('data-cate');
          const action = ele.getAttribute('data-action');
          const label = ele.getAttribute('data-label');
          gaUtil.trackEvent(category, action, label);
          break;
        } else {
          ele = ele.parentNode;
        }
      }
    });
  },
  /**
   * 给页面埋点
   * @param _showHash 是否埋hash
   * @param _pageSelfName 页面自定义name
   */
  trackPageView(_showHash: boolean, _pageSelfName: string) {
    if (g.gtag) {
      let pageSelfName = _pageSelfName;
      if (!pageSelfName) {
        pageSelfName = window.location.pathname + window.location.search;
      }
      pageSelfName += (_showHash ? window.location.hash : '');
      g.gtag('config', GA_TRACKING_ID, { page_path: pageSelfName });
    }
  },

  /**
   * 事件埋点
   * @param category
   * @param action
   * @param optLabel
   */
  trackEvent(category = 'default_category', action = 'default_event', optLabel: any) {
    if (g.gtag) {
      g.gtag('event', 'default_event', {
        event_category: category,
        event_action: action,
        event_label: optLabel,
      });
    }
  },

  /**
   * 天马接口埋点
   * @param action 事件名签名
   * @param parameters 私参对象，不能包含action，否则会覆盖第一个参数
   * @param cb 埋点成功回调
   */
  rTrackEvent(action: string, parameters?: object, cb?: Function) {
    if (g.rtag) {
      g.rtag('_trackEvent', action, parameters, cb);
    }
  },

  /**
   * 设置天马终端ID和密钥
   * @param clientType
   */
  rSetAccount(clientType: CLIENT_TYPE) {
    if (g.rtag) {
      const { account, secret } = rlogClientMap[clientType];
      // 设置天马平台终端ID
      g.rtag('_setAccount', account);
      // 设置秘钥
      g.rtag('_setSecret', secret);
    }
  },

  /**
   * 天马增加公参
   * @param key 参数名
   * @param value 参数值
   */
  rAddPost(key: string, value: string) {
    if (g.rtag) {
      g.rtag('_addPost', key, value);
    }
  },

  /**
   * 天马删除公参
   * @param key 待删除键名
   */
  rRemovePost(key?: string) {
    if (g.rtag) {
      g.rtag('_removePost', key);
    }
  },
  
   /**
   * 天马手动启动发送埋点
   * @param key 待删除键名
   */
  rSetReady() {
    if (g.rtag) {
      g.rtag('_setReady');
    }
  },
};

export default gaUtil;
